import { WelcomeComponent } from "@/components";

export default {
  name: "Contact",
  components: {
    WelcomeComponent,
  },
  setup(props) {},
};
